import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.find.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import draggable from 'vuedraggable'; // 输入 全部分表格列设置
// 输出 要显示的表格列 + 每列的设置

export default {
  name: 'd2-table-columns-filter',
  components: {
    draggable: draggable
  },
  props: {
    options: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: false
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: false
    }
  },
  data: function data() {
    return {
      currentValue: [],
      active: false,
      checkAll: false
    };
  },
  computed: {
    // 显示的数量
    showLength: function showLength() {
      return this.currentValue.filter(function (e) {
        return e.show;
      }).length;
    },
    // 半选状态
    isIndeterminate: function isIndeterminate() {
      var optionsLength = this.options.length;
      var result = this.showLength > 0 && optionsLength !== this.showLength;
      return result;
    }
  },
  watch: {
    options: function options() {
      this.refresh();
    },
    value: function value() {
      this.refresh();
    },
    active: function active(value) {
      if (value === false) {
        this.refresh();
      }
    }
  },
  created: function created() {
    this.refresh();
  },
  methods: {
    // fixed 变化时触发
    fixedChange: function fixedChange(index, value) {
      if (value) this.currentValue[index].show = true;
      if (value === 'left') this.currentValue.unshift(this.currentValue.splice(index, 1)[0]);
      if (value === 'right') this.currentValue.push(this.currentValue.splice(index, 1)[0]);
    },
    // 全选和反选发生变化时触发
    onCheckAllChange: function onCheckAllChange(value) {
      this.currentValue = this.currentValue.map(function (e) {
        e.show = value;
        return e;
      });
    },
    // 根据 value 和 options 计算 currentValue
    // 规则
    // currentValue.length === options.length
    // value.length <= options.length
    refresh: function refresh() {
      var options = this._.cloneDeep(this.options);

      var value = this._.cloneDeep(this.value);

      var currentValueOld = this._.cloneDeep(this.currentValue);

      var currentValue = [];
      var checkAll = true; // 设置比较源

      var compareSource = options;

      if (currentValueOld.length > 0 && currentValueOld.length === options.length) {
        compareSource = currentValueOld;
      } // 计算


      compareSource.forEach(function (option) {
        // 在 value 尝试找到这个项目
        // 没有的话使用 option 中的默认值
        var item = value.find(function (column) {
          return column.id === option.id;
        });
        var show = !!item;
        item = item || option;
        item.show = show;
        if (!show) checkAll = false;
        currentValue.push(item);
      });
      this.currentValue = currentValue;
      this.checkAll = checkAll;
    },
    // 开始选择
    start: function start() {
      this.active = true;
    },
    // 还原
    reset: function reset() {
      this.currentValue = this._.cloneDeep(this.options).map(function (e) {
        e.show = e.show === false ? e.show : true;
        return e;
      });
      this.submit();
    },
    // 确认
    submit: function submit() {
      var result = [];
      this.currentValue.forEach(function (item, index) {
        if (item.show) {
          result.push(item);
        }
      });
      this.$emit('input', result);
      this.$emit('change', result);
      this.active = false;
    }
  }
};